import { Bar, BarChart as RechartsBarChart, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { ChartProps } from './LineChart';

export function BarChart({ data, xKey, yKey, color = '#3b82f6', height = 300 }: ChartProps) {
  return (
    <div style={{ width: '100%', height }}>
      <ResponsiveContainer>
        <RechartsBarChart data={data} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="var(--outline-variant, #e2e8f0)" />
          <XAxis dataKey={xKey} axisLine={false} tickLine={false} tick={{ fontSize: 12, fill: 'var(--on-surface-variant, #64748b)' }} dy={10} />
          <YAxis axisLine={false} tickLine={false} tick={{ fontSize: 12, fill: 'var(--on-surface-variant, #64748b)' }} />
          <Tooltip
            cursor={{ fill: 'var(--surface-variant, #f1f5f9)' }}
            contentStyle={{ backgroundColor: 'var(--surface, #ffffff)', borderRadius: '8px', border: '1px solid var(--outline, #e2e8f0)' }}
          />
          <Bar dataKey={yKey} fill={color} radius={[4, 4, 0, 0]} />
        </RechartsBarChart>
      </ResponsiveContainer>
    </div>
  );
}
